import { render, staticRenderFns } from "./VuetablePaginationBootstrap.vue?vue&type=template&id=3ec0d9d4&"
import script from "./VuetablePaginationBootstrap.vue?vue&type=script&lang=js&"
export * from "./VuetablePaginationBootstrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports